import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrackAndTraceComponent } from './track-and-trace.component';

const routes: Routes = [
  {
    path: ':id',
    component: TrackAndTraceComponent,
    data: {
      title: 'Track & Trace',
    }
  },
  {
    path: '**',
    component: TrackAndTraceComponent,
    data: {
      title: 'Track & Trace',
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrackAndTraceRoutingModule {
}
